import { filter, reject, sortBy, union } from 'lodash';
import { trackError } from '~/services/logger/error.utils';
import { IProjectType } from '~/components/CompanySettings/ProjectTypes/EditProjectTypesModal';

export const sortProjectTypes = (projectTypes: IProjectType[]) => {
    if (!projectTypes) {
        trackError({
            error: new Error(
                '@projectTypes.utils.ts:sortProjectTypes() invalid "projectTypes"'
            ),
            context: { projectTypes }
        });

        return [];
    }

    let editableTypes = filter(
        projectTypes,
        projectType => projectType.editable
    );
    let nonEditableTypes = reject(
        projectTypes,
        projectType => projectType.editable
    );

    editableTypes = sortBy(editableTypes, projectType =>
        projectType.label.toLowerCase()
    );
    nonEditableTypes = sortBy(nonEditableTypes, projectType =>
        projectType.label.toLowerCase()
    );

    return union(editableTypes, nonEditableTypes);
};
